// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3_gnv","alert":"SettungsInbox_alert__3QfRX"};